import React from 'react';
import { ActiveAuction } from 'src/lib/GlobalDataContext';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { createSlug } from 'src/lib/createSlug';
import { MegaMenuAuctionsCard } from './MegaMenuAuctionsCard';
import { useMegaMenu } from 'src/components/Header/components/MegaMenu/useMegaMenu';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(isSameOrBefore);

export const MegaMenuCurrentAuctionCard = ({ auction }: {auction: ActiveAuction}) => {
  // StartDate and EndDate is in the format YYYY-MM-DD
  // StartTime is in the format HH:mm:ss

  const { megaMenuState } = useMegaMenu();

  const now = dayjs.tz(dayjs(), 'America/Chicago');
  const toNextAuction = (date) => {
    const m = Math.round(dayjs.tz(date, 'America/Chicago').diff(now, 'month', true));
    const d = Math.ceil(dayjs.tz(date, 'America/Chicago').diff(now, 'day', true));
    if(d >= 28) return `${m} month${m !== 1 ? 's' : ''}`;

    return `${d} day${d !== 1 ? 's' : ''}`;
  };

  let live = false;
  let current = false;
  let dayOver = false;

  let time = '';

  try {
    time = dayjs.tz(`${auction.StartDate} ${auction.StartTime}`, 'America/Chicago').format('H:mm a');
  } catch (e) {
    console.error(e);
  }

  if(auction.active) {
    live = true;
  }
  if(dayjs.tz(auction.StartDate, 'America/Chicago').isSameOrBefore(now, 'day') && now.isSameOrBefore(dayjs.tz(auction.EndDate, 'America/Chicago'), 'day')) {
    current = true;
  }

  let todaySession;
  let tomorrowSession;
  if(auction.sessions) {
    auction.sessions.forEach((session) => {
      if(session.Date === now.format('YYYY-MM-DD')) {
        todaySession = session;
      }
      if(session.Date === now.add(1, 'day').format('YYYY-MM-DD')) {
        tomorrowSession = session;
      }
    });
  }

  if(current && !live && todaySession?.AuctionSessionStatus === 4) {
    dayOver = true;
  }

  // Per Scott we have a new alert banner, modal, and button on the header to go to live.  This should always go to the
  // catalog.
  const defaultTo = (auction.CatalogSearchLink && `/catalog/${auction.AuctionID}`)
    || `/gun-auctions/${auction.Slug ? auction.Slug : createSlug(auction.Title)}`;
  // let defaultTo = (live && '/live')
  //   || (auction.CatalogSearchLink && `/catalog/${auction.AuctionID}`)
  //   || `/gun-auctions/${auction.Slug ? auction.Slug : createSlug(auction.Title)}`;

  const buttonLabel = live && 'Bid Now' || auction.CatalogSearchLink && 'Bid Now' || 'View Preview';

  // const isTimedAuction = auction.AuctionTypeID === TIMED_AUCTION_TYPE_ID;
  // const isLiveTimedAuction = isTimedAuction && current;
  // if(isLiveTimedAuction) {
  //   defaultTo = `/catalog/${auction.AuctionID}`;
  // }

  const location = auction.AuctionTypeID == TIMED_AUCTION_TYPE_ID
    ? 'Online'
    : `${auction.LocCity}, ${auction.LocState}`;


  return (
    <MegaMenuAuctionsCard
      src={auction.AuctionImage || 'https://placehold.co/272x210'}
      auction={auction}
      description={location}
      to={defaultTo}
      onPress={() => megaMenuState.close()}
      buttonLabel={buttonLabel}
    />
  );
};
